import web from "../web";

class ClassesService {
    index(token){
        return web.get("/api/classes", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/classes", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/classes/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/classes/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/classes/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    classesmatieresenseignants(token){
        return web.get("/api/classesmatieresenseignants", { headers: { 'Authorization': 'Bearer '+token } })
    }

    classesmatieres(token){
        return web.get("/api/classesmatieres", { headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new ClassesService()